'use client';

import React from 'react';

// Section shell for /integrations: a centered, max-width content column. The
// six pages now live as sub-items of "Integrations" in the MAIN sidebar (see
// nav-main.tsx) — there's no secondary sub-nav column.
export default function IntegrationsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      {/* page-surface opts this section into the preflight-parity reset in
          globals.css — without it, bare <button>s (Switch, kebab triggers)
          keep user-agent chrome (dark border, offset content). */}
      <main data-slot="page-surface" className="min-w-0 overflow-x-hidden">
        {/* Left padding floor of 48px clears the floating SidebarTrigger, which
            always sits 8–40px from the content area's left edge (m-2 + size-8),
            so page headings never sit under it — at any viewport width or
            sidebar state. The centered column over-clears it at wide widths.
            Right padding stays 30px (no trigger there). */}
        {/* 1240px (was 1160) buys back the width the browser-preview's padded
            page area takes from the embed itself. */}
        <div className="mx-auto max-w-[1240px] pb-12 pt-[26px] pl-12 pr-[30px]">{children}</div>
      </main>
    </>
  );
}
